import api from "@/lib/api";
import type { AnswerUpdatePayload } from "../types";
import type { ApiDilemmaAnswer } from "../../dilemmas/types";

const ANSWERS_ENDPOINTS = {
  GET_ONE: (id: string) => `/answers/${id}/`,
  UPDATE: (id: string) => `/answers/${id}/`,
};

export class AnswersHttpRepository {
  async fetchOne(id: string): Promise<ApiDilemmaAnswer> {
    const result = await api.get(ANSWERS_ENDPOINTS.GET_ONE(id));
    return result.data;
  }
  async patch(
    id: string,
    payload: Partial<AnswerUpdatePayload>,
  ): Promise<ApiDilemmaAnswer> {
    const result = await api.patch(ANSWERS_ENDPOINTS.UPDATE(id), payload);
    return result.data;
  }
}
